
import { defineComponent, PropType } from 'vue'
import { TransformerInterface } from '~/store/analyzer/list'
import AnalyzerLogo from '~/components/AnalyzerLogo.vue'

export default defineComponent({
  name: 'FormatterCard',
  components: {
    AnalyzerLogo
  },
  props: {
    formatter: {
      type: Object as PropType<TransformerInterface>,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  emits: ['remove']
})
